export default {
  methods: {
    handleTabsRemove(name) {
      this.$store.commit('removeTab', name);
      this.$router.push({
        path: this.$store.state.activeName,
      });
    },
  },
};
